// extracted by mini-css-extract-plugin
module.exports = {"textCenter":"Start_textCenter__ERzTE","button":"Start_button__1-sd8"};